import { render, staticRenderFns } from "./Bonus.vue?vue&type=template&id=fced18c8&scoped=true&"
import script from "./Bonus.vue?vue&type=script&lang=js&"
export * from "./Bonus.vue?vue&type=script&lang=js&"
import style0 from "./Bonus.vue?vue&type=style&index=0&id=fced18c8&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "fced18c8",
  null
  
)

export default component.exports